// 进度
export const scheduleOptions = [
  { label: "进行中", value: 1 },
  { label: "未开始", value: 2 },
  { label: "已结束", value: 3 },
];
